import {
  combineValidators, required, isPostcodeFormat, isPostcodeInRidderkerk, isStreetAddress, isEmail, isPhone,
  noValidation
} from "../Validators";

export const createBasketFormScheme = (deliveryRequired: boolean) => {
  return {
    email: combineValidators(required, isEmail),
    phone: combineValidators(required, isPhone),
    firstName: required,
    lastName: required,
    postcode: deliveryRequired
      ? combineValidators(required, isPostcodeFormat, isPostcodeInRidderkerk)
      : noValidation,
    address: deliveryRequired
      ? combineValidators(required, isStreetAddress)
      : noValidation,
  } as const;
};

